import { HttpFilter } from "sol-request-angular/dist/comunicacao";
import { Equal } from "sol-request-angular/dist/comunicacao/filter/Equal";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";


export class AgenteSearch {

    cdAgente: number;
    cdUsuario: number;
    nmAgente: String;
    dsEndereco: String;
    nmBairro: String;
    nrCep: String;
    cdCidade: number;
    nrMatricula: String;
    tpAgente: number;
    cdOrgao: number;
    stAgente: number;
    page: number;
    limit: number;


    constructor(data?: { cdAgente?: number, 
                        cdUsuario?: number, 
                        nmAgente?: string, 
                        dsEndereco?: String,
                        nmBairro?: String,
                        nrCep?: String,
                        cdCidade?: number,
                        nrMatricula?: String,
                        tpAgente?: number,
                        cdOrgao?: number, 
                        stAgente?: number, 
                        page?: number, 
                        limit?: number }) {
        this.cdAgente = data && data.cdAgente;
        this.cdUsuario = data && data.cdUsuario;
        this.nmAgente = data && data.nmAgente;
        this.dsEndereco = data && data.dsEndereco;
        this.nmBairro = data && data.nmBairro;
        this.nrCep = data && data.nrCep;
        this.cdCidade = data && data.cdCidade;
        this.nrMatricula = data && data.nrMatricula;
        this.tpAgente = data && data.tpAgente;
        this.cdOrgao = data && data.cdOrgao;
        this.stAgente = data && data.stAgente;
        this.page = data && data.page;
        this.limit = data && data.limit;
    }

    getFilters(): IFilter {
        let filtros: IFilter = new HttpFilter([]);

        if (this.cdAgente) {
            filtros.addFilter(new Equal('cdAgente', this.cdAgente));
        }

        if (this.cdUsuario) {
            filtros.addFilter(new Equal('cdUsuario', this.cdUsuario));
        }

        if (this.nmAgente) {
            filtros.addFilter(new Equal('nmAgente', this.nmAgente));
        }

        if (this.dsEndereco) {
            filtros.addFilter(new Equal('dsEndereco', this.dsEndereco));
        }

        if (this.nmBairro) {
            filtros.addFilter(new Equal('nmBairro', this.nmBairro));
        }

        if (this.nrCep) {
            filtros.addFilter(new Equal('nrCep', this.nrCep));
        }

        if (this.cdCidade) {
            filtros.addFilter(new Equal('cdCidade', this.cdCidade));
        }

        if (this.nrMatricula) {
            filtros.addFilter(new Equal('nrMatricula', this.nrMatricula));
        }

        if (this.tpAgente && this.tpAgente != null) {
            filtros.addFilter(new Equal('tpAgente', this.tpAgente));
        }

        if (this.cdOrgao) {
            filtros.addFilter(new Equal('cdOrgao', this.cdOrgao));
        }

        if (this.stAgente && this.stAgente != null) {
            filtros.addFilter(new Equal('stAgente', this.stAgente))
        }

        if (this.limit) {
            filtros.addFilter(new Equal('limit', this.limit))
        }

        if (this.page) {
            filtros.addFilter(new Equal('page', this.page))
        }

        return filtros;
    }
}
